import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SaveIcon from '@mui/icons-material/Save';

interface props {
    handleOpenToast: ((message: string, severity: 'success' | 'error') => void);
}

export const AddActivity: React.FC<props> = ({ handleOpenToast }) => {
    const navigate = useNavigate();

    const [activityName, setActivityName] = useState<string>("");
    const [activityDescription, setActivityDescription] = useState<string>("");
    const [startActivity, setStartActivity] = useState<Dayjs | null>(dayjs());
    const [endActivity, setEndActivity] = useState<Dayjs | null>(dayjs().add(1, 'day'));
    const [openDialog, setOpenDialog] = useState<boolean>(false);

    const handleCancel = () => {
        navigate("/planning");
    }

    const handleSubmit = () => {
        if(activityName === "" || activityDescription === "")
            return;

        // TODO: Implementare API per inserimento attività
        // let data = {
        //     "name": activityName,
        //     "description": activityDescription,
        //     "date_start": startActivity?.toISOString(),
        //     "date_end": endActivity?.toISOString(),
        //     "resources": "",
        //     "id_building": "1",
        //     "status": "CREATA"
        // };
        // insertActivityAWS(data, (err, res) => {
        //     if(err !== null || res === null || res.status !== 200){
        //         handleOpenToast("Si è verificato un problema, riprova più tardi.", 'error');
        //         return;
        //     }
        //     setOpenDialog(true);
        // });
        handleOpenToast("Funzionalità non disponibile - endpoint da implementare su API Gateway", 'error');
    }

    useEffect(() => {
        if(startActivity?.isAfter(endActivity)){
            setEndActivity(startActivity.add(1, 'day'));
        }
    }, [startActivity, endActivity, setEndActivity]);

    useEffect(() => {
        if(endActivity?.isBefore(startActivity)) {
            setStartActivity(endActivity.subtract(1, 'day'));
        }
    }, [endActivity, startActivity, setStartActivity]);

    return (<>
        <div className='panel-title'>
            <h1>AGGIUNGI ATTIVIT&Agrave;</h1>
            <Button variant="outlined" disableElevation 
                size="large" startIcon={<ArrowBackIosNewIcon />}
                onClick={ e => handleCancel() }
            >Indietro</Button>
        </div>
        <Box className='panel-content' component="form" autoComplete="off">
            <div>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker label="Inizio" value={startActivity} onChange={(newValue) => setStartActivity(newValue)} minDate={dayjs()}/>
                    <DatePicker label="Fine" value={endActivity} onChange={(newValue) => setEndActivity(newValue)} minDate={dayjs().add(1, 'day')} sx={{marginLeft: '30px'}}/>
                </LocalizationProvider>
                <TextField fullWidth variant="outlined" margin="normal" required={true} error={activityName === ""} value={activityName} onChange={e => {setActivityName(e.target.value)}} name="activityName" label="Nome" />
                <TextField fullWidth variant="outlined" margin="normal" required={true} error={activityDescription === ""} value={activityDescription} onChange={e => {setActivityDescription(e.target.value)}} name="activityDescription" label="Descrizione" />
            </div>
            <div className='bottom-btns'>
                <Button disableElevation size="large" variant="contained" endIcon={<SaveIcon/>} onClick={e=> handleSubmit()}>Salva</Button>
                <Button disableElevation size="large" variant="outlined" endIcon={<RestartAltIcon/>} onClick={e=> handleCancel()}>Svuota</Button>
            </div>
        </Box>
        <Dialog
            open={openDialog}
            onClose={handleCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>Carica Documento <CheckCircleOutlineIcon/>
                </div>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                L'attività è stata inserita con successo
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCancel} autoFocus>
                OK
              </Button>
            </DialogActions>
        </Dialog>
    </>);
}